import * as React from 'react';
import * as classNames from 'classnames';

import './styles.scss';

import Icon from '../Icon';
import { Toaster } from '../Toaster';

export interface IToastProps {
    /** Toast intent */
    intent: 'success' | 'danger';
    /** Text to display */
    text: string;
    /** Clicking toast should dismiss it */
    dismissOnClick?: boolean;
    /** Click event handler */
    onClick?: (event) => void;
    /** Dismiss handler */
    onDismiss?: (didTimeoutExpire: boolean) => void;
    /** Key for dismissal */
    toastKey?: string;
    /** Jiggle effect */
    jiggle?: boolean;
    /** Milliseconds to wait before automatically dismissing toast. Providing a value less than or equal to 0 will disable the timeout (this is discouraged).
     */
    timeout?: number;
}

interface IState {
}

/**
 * Content to display within Toaster component.
 */
export default class Toast extends React.Component<IToastProps, IState> {
    static displayName: string = 'Toast';

    render () {
        return (

            <div
                className={classNames('toast-content', {
                    'intent-danger': this.props.intent === 'danger',
                    'intent-success': this.props.intent === 'success',
                    'jiggle': this.props.jiggle,
                })}
                onClick={(e) => {
                    e.preventDefault();
                    if (this.props.onClick) {
                        this.props.onClick(e);
                    }
                    if (this.props.toastKey) {
                        Toaster.dismiss(this.props.toastKey);
                    } else {
                        Toaster.clear();
                    }
                }}
            >
                {this.props.intent === 'success' && <Icon kind="status-success" width={36} height={36} wrapperClassName="toast-content-icon" />}
                {this.props.intent === 'danger' && <Icon kind="status-error" width={36} height={36} wrapperClassName="toast-content-icon" />}
                <div className="toast-content-text">{this.props.text}</div>
            </div>

        );
    }
}
